module.exports = __webpack_public_path__ + "static/media/empty01_scoping1_anim.1474cb25.svg";